module.exports = __webpack_public_path__ + "assets/images/fallback-portrait.png";